import React from 'react';
import './pagestyles/Industries.css';
import BottomBanner from './BottomBanner';

const Industries = () => {
  return (
     <>
    <div className="page-container">
      <div className="page-header">
        <h1>Industries</h1>
        <p className="page-subtitle">Coverage across automotive, energy, retail, and more</p>
      </div>
      
      <div className="page-content">
        <div className="content-grid">
          <a href="/article/electric-vehicle-sales-surge" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=600&h=400&fit=crop" alt="Automotive industry" />
            </div>
            <div className="article-content">
             <h2>Electric Vehicle Sales Surge Globally</h2>
              <p>Major automakers report record EV sales as consumer demand continues to accelerate worldwide.</p>
              <span className="article-meta">1 hour ago</span>
            </div>
          </a>

          <a href="/article/renewable-energy-investment-high" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?w=600&h=400&fit=crop" alt="Energy sector" />
            </div>
            <div className="article-content">
           
              <h2>Renewable Energy Investment Hits New High</h2>
              <p>Global investment in renewable energy infrastructure reaches unprecedented levels this quarter.</p>
              <span className="article-meta">3 hours ago</span>
            </div>
          </a>

          <a href="/article/ecommerce-growth-continues" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600&h=400&fit=crop" alt="Retail sector" />
            </div>
            <div className="article-content">
              
              <h2>E-Commerce Growth Continues Strong</h2>
              <p>Online retail sales show robust growth as digital transformation reshapes the shopping experience.</p>
              <span className="article-meta">5 hours ago</span>
            </div>
          </a>
        </div>
      </div>
    </div>

      <BottomBanner />
       </>

  );
};

export default Industries;
